import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import {googleAnalyticsHeadScripts} from './assets/ga/script';


googleAnalyticsHeadScripts();

platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/main.ts